module.exports = __webpack_public_path__ + "img/bg_function04_2_t.c8051b07.png";